import Dashboard from "../../views/dashboard/Dashboard.vue";

const channelaudit = {
  path: "/channelauditmanagement",
  name: "channelauditmanagement",
  redirect: "channelaudit",
  component: Dashboard,
  meta: {
    title: "工程设置",
    icon: "el-icon-setting",
    role: false
  },
  children: [
    {
      path: "/channelaudit",
      name: "channelaudit",
      component: () =>
        import("../../components/channelauditmanagement/channelaudit.vue"),
      meta: {
        title: "通道设置",
        icon: "el-icon-s-operation",
        role: false
      }
    },
    {
      path: "/hardware",
      name: "hardware",
      component: () =>
        import(
          "../../components/channelauditmanagement/hardwaremanagement.vue"
        ),
      meta: {
        title: "硬件设置",
        icon: "el-icon-receiving",
        role: false
      }
    },
    {
      path: "/propertyset",
      name: "propertyset",
      component: () =>
        import(
          "../../components/channelauditmanagement/propertymanagement.vue"
        ),
      meta: {
        title: "物业设置",
        icon: "el-icon-office-building",
        role: false
      }
    },
    {
      path: "/regoinmanagement",
      name: "regoinmanagement",
      component: () =>
        import("../../components/channelauditmanagement/regoinmanagement.vue"),
      meta: {
        title: "区域设置",
        icon: "el-icon-position",
        role: false
      }
    }
  ]
};

export default channelaudit;
